export default {
  presenter: 'snajdr',
  title: 'vpsAdminOS: lehká distribuce pro vaše kontejnery',
  subtitle: 'mírně pokročilí',
  text: `
vpsAdminOS je minimalistický operační systém, který běží kompletně v RAM a je postaven na NixOS.
Dovoluje rychle vytvořit prostředí pro běh kontejnerů, které jsou spravovány naší vlastní utilitou
a uloženy na ZFS. Spustit vlastní prostředí pro bezpečný běh kontejnerů můžete už během několika minut!
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/snajdr-vpsadminos.js